const getBenchmarkingAppliedFilters = ({ report: { benchmarkingFilters } }) => ({
  benchmarkingAppliedFilters: benchmarkingFilters.applied,
  benchmarkingAppliedFiltersRequestStatus: benchmarkingFilters.appliedRequestStatus,
  benchmarkingShouldUpload: benchmarkingFilters.shouldUpload,
});

export default getBenchmarkingAppliedFilters;
